import type { IArticleTypeSchema } from "../types/models/ArticleType.model";
import type { IArticleTypes } from "../types";

export const ArticleTypeModel2Interface = (
  articleTypes?: IArticleTypeSchema[]
): IArticleTypes[] => {
  if (!articleTypes) return [];

  return articleTypes.map((articleTypeMode) => {
    return {
      articleTypeId: articleTypeMode.ArticleTypeId,
      name: articleTypeMode.Name
    };
  });
};
